import React from "react";
import { ChangePasswordView } from "../../views";
import {
  Auth0Service,
  LocalStorageService,
  UserService,
} from "../../../services";

class ChangePasswordAction extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  state = {
    userId: "",
    clientId: "",
    userTypeId: "",
    languageId: "",
    email: "",

    password: "",
    confirmPassword: "",
    actualPassword: "",
    actualPasswordShowPasswordIcon:
      "changePasswordView-show-password-icon-desactive",
    changePasswordShowPasswordIcon:
      "changePasswordView-show-password-icon-desactive",
    changePasswordShowPasswordConfirmIcon:
      "changePasswordView-show-password-icon-desactive",
    errorForm: false,
    errorMessage: "",

    showLoadingRequesting: false,
    showCompletedRequesting: false,
    showErrorRequesting: false,
    flags: [
      {
        language: 'es',
        src: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_LANGUAGE_MX}`,
        label: 'ES',
        status: true
      },
      {
        label: '|',
        status: false
      },
      {
        language: 'en',
        src: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_LANGUAGE_US}`,
        label: 'EN',
        status: false
      }
    ]

  };

  token = {};
  user = {};
  location = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  auth0Service = new Auth0Service();
  userService = new UserService(this.url);

  async componentDidMount() {
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    this.user = this.localStorageService.getLocalStorageItem("user");
    this.location = this.localStorageService.getLocalStorageItem("url");
    let userInformation = this.user.userMetaData.userA3Cloud;
    let userInformationAkubicaFirmaDigital = this.user.userMetaData.userMifirma;

    this.setState({
      userId: userInformation.id,
      userTypeId: userInformationAkubicaFirmaDigital.userType.id,
      languageId: userInformationAkubicaFirmaDigital.language.id,
      clientId: userInformation.clientId,
      email: userInformation.email,
    });
  }

  /**
   * @author Alan Aguilar
   * @description Method to show the loading dialog modal
   * @date 15-12-2020
   * @memberof RegisterUserInvitedAction
   */
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the complete request dialog modal
   * @date 15-12-2020
   * @memberof RegisterUserInvitedAction
   */
  toggleCompletedRequesting = (value) => {
    this.setState(
      {
        showCompletedRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showCompletedRequesting: false });
          if (this.props.goToChangePasswordScreen) {
            this.props.goToChangePasswordScreen();
          } else if (this.props.redirectToChangePass) {
            window.location.href = this.location;
            window.location.reload();
          } else {
            window.location.reload();
          }
        }, 1000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the Error request dialog modal
   * @date 15-12-2020
   * @memberof RegisterUserInvitedAction
   */
  toggleErrorRequesting = (value) => {
    this.setState(
      {
        showErrorRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false });
        }, 4000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to hide and show the label error
   * @date 15-12-2020
   * @memberof AuthService
   */
  onHandleHideError = () => {
    this.setState({
      errorForm: false,
      errorMessage: "",
    });
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to hide and show the password icon and text in Change Password form
   * @date 15-12-2020
   * @memberof AuthService
   */
  onHandleShowPassword = () => {
    let { changePasswordShowPasswordIcon } = this.state;
    let inputPassword = document.querySelector("#password");

    if (
      changePasswordShowPasswordIcon ===
      "changePasswordView-show-password-icon-desactive" &&
      inputPassword.type === "password"
    ) {
      inputPassword.type = "text";
      this.setState({
        changePasswordShowPasswordIcon:
          "changePasswordAction-password-icon-active",
      });
    } else {
      inputPassword.type = "password";
      this.setState({
        changePasswordShowPasswordIcon:
          "changePasswordView-show-password-icon-desactive",
      });
    }
  };

  /**
 * @author Edgar Escobedo
 * @description Handler method to hide and show the password icon and text in actual Password form
 * @date 15-03-2024
 * @memberof AuthService
 */
  onHandleShowActualPassword = () => {
    let { actualPasswordShowPasswordIcon } = this.state;
    let inputPassword = document.querySelector("#actualPassword");

    if (
      actualPasswordShowPasswordIcon ===
      "changePasswordView-show-password-icon-desactive" &&
      inputPassword.type === "password"
    ) {
      inputPassword.type = "text";
      this.setState({
        actualPasswordShowPasswordIcon:
          "changePasswordAction-password-icon-active",
      });
    } else {
      inputPassword.type = "password";
      this.setState({
        actualPasswordShowPasswordIcon:
          "changePasswordView-show-password-icon-desactive",
      });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to hide and show the confirmPassword icon and text in Change Password form
   * @date 15-12-2020
   * @memberof AuthService
   */
  onHandleShowPasswordConfirm = () => {
    let { changePasswordShowPasswordConfirmIcon } = this.state;
    let inputPassword = document.querySelector("#confirmPassword");

    if (
      changePasswordShowPasswordConfirmIcon ===
      "changePasswordView-show-password-icon-desactive" &&
      inputPassword.type === "password"
    ) {
      inputPassword.type = "text";
      this.setState({
        changePasswordShowPasswordConfirmIcon:
          "changePasswordAction-password-icon-active",
      });
    } else {
      inputPassword.type = "password";
      this.setState({
        changePasswordShowPasswordConfirmIcon:
          "changePasswordView-show-password-icon-desactive",
      });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method for capture the information in all inputs
   * @date 15-12-2020
   * @param {Object} e
   * @memberof AuthService
   */
  onHandleGeneralChange = (e) => {
    this.setState({
      ...this.state,
      [e.target.id]: e.target.value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to change the user password in the register invited
   * @date 15-12-2020
   * @memberof RegisterUserInvitedAction
   */
  onSubmitChangeUserPassword = async (t) => {
    let { password, confirmPassword, actualPassword } = this.state;
    let regexToValidate = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*[.@#$%^&*!_-])[A-Za-z\d!@#$%^&*._-]{10,16}$/

    let passwordValue = password.trim();
    let confirmPasswordValue = confirmPassword.trim();
    let actualPasswordValue = ''
    let verifyActualPassword = false

    if (this.props.isProfileView) {
      if (!actualPassword || !passwordValue || !confirmPasswordValue) {
        let messageError = t("changePasswordView.errorConfirmationPassword")
        if (!passwordValue) messageError = t("changePasswordView.errorNewPassword")
        if (!actualPassword) messageError = t("changePasswordView.errorCurrentPassword")

        this.setState({
          errorForm: true,
          errorMessage: messageError
        }, () => {
          setTimeout(() => {
            this.setState({
              errorForm: false,
              errorMessage: "",
            });
          }, 5000);
        })
        return
      } else {
        actualPasswordValue = actualPassword.trim()
        verifyActualPassword = true
      }
    }

    // Validate that both passwors are equal
    if (!(passwordValue === confirmPasswordValue)) {
      this.setState(
        {
          errorForm: true,
          errorMessage: t("login.action.errorPass")
        },
        () => {
          setTimeout(() => {
            this.setState({
              errorForm: false,
              errorMessage: "",
            });
          }, 5000);
        }
      );
      return false;
    }

    // Validate if the passwords has more that 8 letters
    if (!passwordValue.match(regexToValidate)) {
      this.setState(
        {
          errorForm: true,
          errorMessage:
            t("changePasswordView.errorValidPassword"),
        },
        () => {
          setTimeout(() => {
            this.setState({
              errorForm: false,
              errorMessage: "",
            });
          }, 5000);
        }
      );
      return false;
    }

    try {
      if (this.props.isProfileView) {
        this.props.toggleLoadingRequestingProfile(true)
      } else {
        await this.toggleLoadingRequesting(true);
      }
      // Calling service to change password
      let changePassword = await this.auth0Service.changePasswordRequest(
        confirmPasswordValue,
        this.token,
        null,
        verifyActualPassword,
        actualPassword
      );

      if (!(Number(changePassword.data.statusCode) === 200)) {
        if (Number(changePassword.data.statusCode) === -10) {
          throw new Error("Contraseña actual incorrecta");
        }
        throw new Error("No se pudo cambiar la contraseña del usuario");
      }

      if (this.props.isProfileView) {
        this.props.toggleLoadingRequestingProfile(false)
        this.props.toggleCompletedRequestingProfile(3000, false, '/')
        this.props.handleShowPrincipalView()
      } else {
        await this.toggleLoadingRequesting(false);
        await this.toggleCompletedRequesting(true);
      }
    } catch (error) {
      if (this.props.isProfileView) {
        let messageError = 'No se pudo cambiar la contraseña del usuario'
        if (error.message === "Contraseña actual incorrecta") {
          messageError = "Contraseña actual incorrecta"
        }
        this.props.toggleLoadingRequestingProfile(false)
        this.props.toggleErrorRequestingProfile(messageError, 4000, false, '/')
      } else {
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
      }
      return false;
    }
  };

  setFlags = (language) => {
    if (!language) return
    let flags = this.state.flags.map((flag) => {
      flag.status = (language === flag.language) ? true : false
      return flag
    })

    this.setState({
      flags
    })
  }

  render() {
    return (
      <ChangePasswordView
        {...this.state}
        {...this.props}
        flagsPassword={this.state.flags}
        setFlagsPassword={this.setFlags}
        onSubmitChangeUserPassword={this.onSubmitChangeUserPassword}
        onHandleGeneralChange={this.onHandleGeneralChange}
        goToChangePasswordScreen={this.props.goToChangePasswordScreen}
        onHandleShowPassword={this.onHandleShowPassword}
        onHandleShowPasswordConfirm={this.onHandleShowPasswordConfirm}
        onHandleHideError={this.onHandleHideError}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleErrorRequesting={this.toggleErrorRequesting}

        //ProfileView
        onHandleShowActualPassword={this.onHandleShowActualPassword}
      />
    );
  }
}
export { ChangePasswordAction as default };
